// generated by the scripts in scripts/
export default '/terrain/cl-6b9d1ca3'
